module.exports = __webpack_public_path__ + "static/img/rmp_tagline.32de28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rmp_tagline.png
// module id = zHD6
// module chunks = 3